import { render, staticRenderFns } from "./ViewEstimateComponent.vue?vue&type=template&id=24b318c9"
import script from "./ViewEstimateComponent.vue?vue&type=script&lang=js"
export * from "./ViewEstimateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports